import AlertsCollapse from '../AlertsCollapse/AlertsCollapse'
import CountdownButton from '../../components/CountdownButton/CountdownButton'
import { useGetPatientAlertsQuery } from '../../state/alerts/api'
import { AlertsViewContainer } from './AlertsViewStyle'
import Header from '../CyHeader/CyHeader'
import { ReactComponent as AlertIconIconFilled } from '../../assets/Icons_Alerts Fill.svg'
import Icon from '@ant-design/icons'
import { useEffect } from 'react'
import { displayMessage } from '../../helpers/Message'
import { message } from 'antd'

function AlertsView() {
  const { refetch, isLoading, error } = useGetPatientAlertsQuery({})
  const refreshTimeInSeconds = 30
  const [messageApi, contextHolder] = message.useMessage()
  const onCountdownFinish = () => {
    refetch()
  }
  useEffect(() => {
    let errorData = error as any
    let message = errorData?.data?.message
    if (message) {
      displayMessage(message as string, 'error', messageApi)
    }
  }, [isLoading])

  return (
    <div style={{ height: 'calc(100vh - 70px)' }}>
      {contextHolder}
      <Header
        title={
          <>
            <Icon
              component={AlertIconIconFilled}
              style={{ fontSize: '150%' }}
            />
            <h2>Alerts</h2>
            <CountdownButton
              countDownTimeInSeconds={refreshTimeInSeconds}
              label='Auto refreshing in'
              onCountdownFinish={onCountdownFinish}
            />
          </>
        }
      />
      <AlertsViewContainer>
        <AlertsCollapse />
      </AlertsViewContainer>
    </div>
  )
}

export default AlertsView
